import { render } from "./BlogBoneCrafts.vue?vue&type=template&id=7db1bc43"
import script from "./BlogBoneCrafts.vue?vue&type=script&lang=js"
export * from "./BlogBoneCrafts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__